import styled from "styled-components";

const PageContent = styled.div`
  box-sizing: border-box;
  padding: 1.25rem;
  margin: auto;
  @media (min-width: 46rem) {
    max-width: 75rem;
    padding: 1.5rem;
  }
`;

export default PageContent;
